import { render, staticRenderFns } from "./ReaderDetail.vue?vue&type=template&id=098dd8ba&lang=pug"
import script from "./ReaderDetail.vue?vue&type=script&lang=js"
export * from "./ReaderDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports